module.exports = __webpack_public_path__ + "img/bg-section-05.12484e40.svg";